module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "calendar",
    attrs: {
      "id": "calendar"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-467b2bdf!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-full-calendar/components/FullCalendar.vue
// module id = 601
// module chunks = 97